<template>
  <ModalComponent :show="true" clickaway class="site-navigation-item-modal" @close="$emit('close')">
    <Card tag="form" variant="prompt" :title="title" @submit.prevent.stop="$emit('submit', item)">
      <div class="site-navigation-item-modal__fields">
        <div v-if="!systemItem" class="site-navigation-item-modal__field">
          <label>{{ $t('menuItemLinksTo') }}</label>
          <LinkPicker
            :value="item.link || {}"
            :pages="pages"
            :anchors="anchors"
            :units="units"
            :type="type"
            :nested="nested"
            @input="setLink"
          />
        </div>

        <InputComponent
          v-model="item.label"
          :label="$t('menuItemName')"
          :placeholder="systemItem ? systemItem.label : ''"
          :required="!systemItem"
        />

        <div v-if="variants" class="site-navigation-item-modal__field">
          <label>{{ $t('menuItemVisualStyle') }}</label>
          <ChoiceComponent :value="variant" :values="variantItems" @input="$ev => (item.variant = $ev)" />
        </div>

        <div v-if="placements && !systemItem && !isChild" class="site-navigation-item-modal__field">
          <label>{{ $t('placement') }}</label>
          <ChoiceComponent
            :value="item.placement || 'default'"
            :values="placementItems"
            @input="$ev => (item.placement = $ev)"
          />
        </div>

        <div v-if="visibility" class="site-navigation-item-modal__field">
          <label>{{ $t('menuItemVisibility') }}</label>
          <CheckboxComponent
            :value="!item.hideInMenu"
            :label="$t('menuItemShowInMenu')"
            theme="toggle"
            @input="$ev => (item.hideInMenu = !$ev)"
          />
          <CheckboxComponent
            :value="!item.hideInFooter"
            :label="$t('menuItemShowInFooter')"
            theme="toggle"
            @input="$ev => (item.hideInFooter = !$ev)"
          />
        </div>
      </div>

      <template #actions>
        <ButtonComponent :label="$t('cancel')" @click="$emit('close')" />
        <ButtonComponent :label="$t('confirm')" :icon="['fal', 'check']" theme="primary" type="submit" />
      </template>
    </Card>
  </ModalComponent>
</template>

<script>
import { ModalComponent } from 'vue-elder-modal'
import { InputComponent } from 'vue-elder-input'
import { CheckboxComponent } from 'vue-elder-checkbox'
import { ChoiceComponent } from 'vue-elder-choice'
import { Clone } from '@/utils'
import Card from '@/components/Card-v2'
import LinkPicker from './LinkPicker'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    systemItem: Object,
    isChild: Boolean,
    pages: Array,
    anchors: Object,
    units: Array,
    type: String,
    nested: Boolean,
    variants: Boolean,
    visibility: Boolean,
    placements: Boolean,
  },
  data() {
    return {
      item: {
        label: '',
        link: null,
        ...(this.variants && { variant: null }),
        ...(this.placements && { placement: null }),
        ...(this.visibility && { hideInMenu: false, hideInFooter: false }),
        ...Clone(this.value),
      },
      autoLabel: '',
    }
  },
  computed: {
    title() {
      if (this.systemItem) return this.$t('menuItemEditSystem', { label: this.systemItem.label })
      return this.value.label ? this.$t('menuItemEdit') : this.$t('menuItemNew')
    },
    variant() {
      return this.item.variant || (this.systemItem && this.systemItem.variant) || 'tertiary'
    },
    variantItems() {
      return [
        { value: 'tertiary', label: this.$tc('link', 1) },
        { value: 'secondary', label: this.$t('menuItemButtonSecondary') },
        { value: 'primary', label: this.$t('menuItemButtonPrimary') },
      ]
    },
    placementItems() {
      return [
        { value: 'default', label: this.$t('menuBar') },
        { value: 'bar', label: this.$t('hamburgerMenu') },
      ]
    },
  },
  methods: {
    setLink(link, label) {
      this.item.link = link
      if (!label) return

      const isAutoLabel = !this.item.label || this.item.label === this.autoLabel
      if (isAutoLabel) this.item.label = label
      this.autoLabel = label
    },
  },
  components: {
    ModalComponent,
    InputComponent,
    CheckboxComponent,
    ChoiceComponent,
    Card,
    LinkPicker,
  },
}
</script>

<style lang="scss">
.site-navigation-item-modal {
  .card-v2 {
    width: 600px;
    max-width: 100%;
  }

  &__fields {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  &__field {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    & > label {
      font-weight: bold;
    }
  }

  .elder-choices {
    flex-wrap: nowrap;
    gap: 0.5rem;
    margin: 0;

    &__item {
      margin: 0;

      &-label {
        padding: 0.75rem 1rem;
      }
    }
  }
}
</style>
